// Load jQuery
import $ from 'jquery';
import WebFont from 'webfontloader';

window.$ = window.jQuery = $;

$.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
$.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
$.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
import 'flatpickr/dist/flatpickr.min';
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'select2/dist/js/select2.full.min';
import '@accessible360/accessible-slick/slick/slick.min';

// Require the Swiper initialization module
import initSwiper from './modules/swiper';
initSwiper(); 

//Load Modules
import './modules/accordion';
import './modules/animatein';
import './modules/bannerVideo';
import './modules/formInputs';
import './modules/gfSteps'; // only include if using WordPress Gravity plug;
import './modules/gravityForms'; // only include if using WordPress Gravity plug;
import './modules/videoButtonReplacer';
import './modules/videoPopup';
import './modules/videoPlay';
import './modules/menu';
import './modules/modal';
import './modules/scrollTo';
import './modules/searchToggle';
import './modules/shareSocial';
import './modules/sideMenu';
import './modules/tabs';
import './modules/alert';
import './modules/resourceAlert';
import './modules/handlebars';
import './modules/donation-form.js';
import "./corner-element.js";
import "./react/news-listing/news-listing.jsx";
import "./react/mega-nav/mega-nav.jsx";
import "./react/mega-nav/results-info.jsx";


